import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError, EMPTY, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  catchError,
  map,
  publishReplay,
  refCount,
  share,
} from 'rxjs/operators';
import { AppConfigService } from '../services/config.service';

let headers = new HttpHeaders({
  // 'Content-Type': 'application/json',
  // 'Access-Control-Allow-Origin':  'http://127.0.0.1:4200',
  // 'Access-Control-Allow-Methods': ', GET',
  // 'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  // 'Access-Control-Allow-Credentials': 'true',
  user_token: localStorage.getItem('token'),
});
let options = { headers: headers };

@Injectable({
  providedIn: 'root',
})
export class ObsService {
  public _patient;

  addItem(patient) {
    this._patient = patient;
  }

  get patient() {
    return this._patient;
  }

  private url = this.conf.appConfig.apiBaseUrl;

  constructor(private client: HttpClient, private conf: AppConfigService) {}

  public getDropdown() {
    const url = `${this.url}/api/dropdown/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getObsResult(result_id) {
    let option = { headers: headers };
    const url = `${this.url}/api/obs/result/gettokenvalues?result_id=${result_id}`;

    return this.client.get(url, option).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getObsResultOnline(result_id) {
    let headers = new HttpHeaders({
      user_token: 'ZpStOb1ScvlMDWNV8QL9H1+vWYg7GbrA7GlQiZmesu8=',
    });
    let option = { headers: headers };
    const url = `${this.url}/api/online/result/fetch?id=${result_id}`;

    return this.client.get(url, option).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getSinglePatient(id) {
    let option = { headers: headers };
    const url = `${this.url}/api/patient/getall?id=${id}`;

    return this.client.get(url, option).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getRefDr(id) {
    let option = { headers: headers };
    const url = `${this.url}/api/refdoctor/getall?id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, option).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getTitle(id) {
    const url = `${this.url}/api/titles/getall?id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getdr(id) {
    let option = { headers: headers };
    const url = `${this.url}/api/employees/getallemployees?id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, option).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public deleteDropdown(Id: 0, IsDropdown: boolean, IsDropdownValue: boolean) {
    const data = {
      Id,
      IsDropdown,
      IsDropdownValue,
    };
    console.log(data);
    const url = `${this.url}/api/dropdown/delete`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public printResult(id) {
    const url = `${this.url}/api/lab/result/print?result_id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getDropdownValues(id) {
    const url = `${this.url}/api/dropdown/values/getall?dropdown_id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getPatient(id) {
    let option = { headers: headers };
    const url = `${this.url}/api/patient/getall?id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, option).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public refreshResult(result_id) {
    let option = { headers: headers };
    const url = `${this.url}/api/obs/result/refresh?result_id=${result_id}`;

    return this.client.get(url, option).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getImage(path) {
    const url = `${this.url}/api/obs/get/image?path=${path}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getDrs() {
    const url = `${this.url}/api/employees/getallemployees?category_id=1`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public createDropdown(Id: number, Name: string) {
    const data = {
      Id,
      Name,
    };
    console.log(data);
    const url = `${this.url}/api/dropdown/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public createDropdownValue(
    Id: number,
    DropdownId: number,
    OptionName: string,
    OptionValue: string,
    OptionCode: string,
    IsActive: boolean
  ) {
    const data = {
      Id,
      DropdownId,
      OptionName,
      OptionValue,
      OptionCode,
      IsActive,
    };
    console.log(data);
    const url = `${this.url}/api/dropdown/values/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public getFTSingle(id) {
    const url = `${this.url}/api/obs/first/trimester/single/get?result_id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  public getFTTwin(id) {
    const url = `${this.url}/api/obs/first/trimester/twins/get?result_id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  public getFTTriplet(id) {
    const url = `${this.url}/api/obs/first/trimester/triplet/get?result_id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  public getST(id) {
    const url = `${this.url}/api/obs/second/trimester/get?result_id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  public getTT(id) {
    const url = `${this.url}/api/obs/third/trimester/get?result_id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public postFTSinge(
    result_id: number,
    single: {
      ftsingle_id: number;
      patient_id: number;
      referance_id: number;
      author_id: number;
      branch_code: string;
      sex: string;
      lmp: string;
      ga: string;
      edd: string;
      no_of_fetus: string;
      tech_condition: string;
      fetal_heart_beat: string;
      mean_gsd: string;
      crl: string;
      nt_thikness: string;
      amniotic_fluid: string;
      p_location: string;
      us_average: string;
      uss_edd: string;
      gender: string;
      right_adnexium: string;
      left_adnexium: string;
      cervical_os: string;
      bpd: string;
      fl: string;
      ac: string;
      hc: string;
      efw: string;
      other_finding: string;
      comments: string;
      suggestion1: string;
      suggestion2: string;
      suggestion3: string;
      ftimage: string;
      fin_year: string;
      entry_date: string;
      update_entry_date: string;
      doctor_id: number;
    }
  ) {
    const data = {
      result_id,
      single,
    };
    console.log(data);
    const url = `${this.url}/api/obs/first/trimester/single/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public postFTTwins(
    result_id: number,
    first: {
      fttwin1_id: number;
      patient_id: number;
      referance_id: number;
      author_id: number;
      update_author_id: number;
      branch_code: string;
      sex: string;
      lmp: string;
      ga: string;
      edd: string;
      no_of_fetus: string;
      chorionicity: string;
      amnionicity: string;
      fetal_heart_beat: string;
      mean_gsd: string;
      crl: string;
      nt_thikness: string;
      bpd: string;
      fl: string;
      ac: string;
      hc: string;
      amniotic_fluid: string;
      p_location: string;
      gender: string;
      us_average: string;
      us_edd: string;
      right_adnexium: string;
      left_adnexium: string;
      cervical_os: string;
      efw: string;
      other_finding: string;
      comments: string;
      suggestion1: string;
      suggestion2: string;
      suggestion3: string;
      ftimage: string;
      fin_year: string;
      entry_date: string;
      update_entry_date: string;
      doctor_id: number;
    },
    second: {
      fttwin2_id: number;
      patient_id: number;
      referance_id: number;
      author_id: number;
      update_author_id: number;
      branch_code: string;
      sex: string;
      lmp: string;
      ga: string;
      edd: string;
      no_of_fetus: string;
      chorionicity: string;
      amnionicity: string;
      fetal_heart_beat: string;
      mean_gsd: string;
      crl: string;
      nt_thikness: string;
      bpd: string;
      fl: string;
      ac: string;
      hc: string;
      amniotic_fluid: string;
      p_location: string;
      gender: string;
      us_average: string;
      us_edd: string;
      right_adnexium: string;
      left_adnexium: string;
      cervical_os: string;
      efw: string;
      other_finding: string;
      comments: string;
      suggestion1: string;
      suggestion2: string;
      suggestion3: string;
      ftimage: string;
      fin_year: string;
      entry_date: string;
      update_entry_date: string;
      doctor_id: number;
    }
  ) {
    const data = {
      result_id,
      first,
      second,
    };
    console.log(data);
    const url = `${this.url}/api/obs/first/trimester/twins/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public postFTTriplet(
    result_id: number,
    first: {
      fttriplet1_id: number;
      patient_id: number;
      referance_id: number;
      author_id: number;
      branch_code: string;
      sex: string;
      lmp: string;
      ga: string;
      edd: string;
      no_of_fetus: string;
      chorionicity: string;
      amnionicity: string;
      fetal_heart_beat: string;
      mean_gsd: string;
      crl: string;
      nt_thikness: string;
      bpd: string;
      fl: string;
      ac: string;
      hc: string;
      amniotic_fluid: string;
      p_location: string;
      gender: string;
      us_average: string;
      us_edd: string;
      right_adnexium: string;
      left_adnexium: string;
      cervical_os: string;
      efw: string;
      no_of_placentae: string;
      grade: string;
      dvp: string;
      other_finding: string;
      comments: string;
      suggestion1: string;
      suggestion2: string;
      suggestion3: string;
      ftimage: string;
      fin_year: string;
      entry_date: string;
      update_entry_date: string;
      doctor_id: number;
    },
    second: {
      fttriplet2_id: number;
      patient_id: number;
      referance_id: number;
      author_id: number;
      branch_code: string;
      sex: string;
      lmp: string;
      ga: string;
      edd: string;
      no_of_fetus: string;
      chorionicity: string;
      amnionicity: string;
      fetal_heart_beat: string;
      mean_gsd: string;
      crl: string;
      nt_thikness: string;
      bpd: string;
      fl: string;
      ac: string;
      hc: string;
      amniotic_fluid: string;
      p_location: string;
      gender: string;
      us_average: string;
      us_edd: string;
      right_adnexium: string;
      left_adnexium: string;
      cervical_os: string;
      efw: string;
      no_of_placentae: string;
      grade: string;
      dvp: string;
      other_finding: string;
      comments: string;
      suggestion1: string;
      suggestion2: string;
      suggestion3: string;
      ftimage: string;
      fin_year: string;
      entry_date: string;
      update_entry_date: string;
      doctor_id: number;
    },
    third: {
      fttriplet3_id: number;
      patient_id: number;
      referance_id: number;
      author_id: number;
      branch_code: string;
      sex: string;
      lmp: string;
      ga: string;
      edd: string;
      no_of_fetus: string;
      chorionicity: string;
      amnionicity: string;
      fetal_heart_beat: string;
      mean_gsd: string;
      crl: string;
      nt_thikness: string;
      bpd: string;
      fl: string;
      ac: string;
      hc: string;
      amniotic_fluid: string;
      p_location: string;
      gender: string;
      us_average: string;
      us_edd: string;
      right_adnexium: string;
      left_adnexium: string;
      cervical_os: string;
      efw: string;
      no_of_placentae: string;
      grade: string;
      dvp: string;
      other_finding: string;
      comments: string;
      suggestion1: string;
      suggestion2: string;
      suggestion3: string;
      ftimage: string;
      fin_year: string;
      entry_date: string;
      update_entry_date: string;
      doctor_id: number;
    }
  ) {
    const data = {
      result_id,
      first,
      second,
      third,
    };
    console.log(data);
    const url = `${this.url}/api/obs/first/trimester/triplet/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public postST(data: []) {
    const payload = [...data];
    console.log(payload);
    const url = `${this.url}/api/obs/second/trimester/save`;

    return this.client.post(url, payload, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public postTT(data: []) {
    // const payload = {
    //   data
    // };
    const payload = [...data];
    console.log(payload);
    const url = `${this.url}/api/obs/third/trimester/save`;

    return this.client.post(url, payload, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}
